<template>

	<v-content>
		<v-container fluid fill-height>
			<v-layout row>


				<v-flex xs12 sm6 offset-sm3>
					<v-card>
						<v-toolbar color="indigo" dark>
							<v-btn icon @click="gotoUsers()">
								<v-icon>arrow_back_ios</v-icon>
							</v-btn>
							<v-toolbar-title v-if="isEdit">Düzenle</v-toolbar-title>
							<v-toolbar-title v-if="!isEdit">Ekle</v-toolbar-title>
							<v-spacer></v-spacer>
							<!-- <v-btn v-if="!isLoading" icon>
								<v-icon>add_circle</v-icon>
							</v-btn> -->
						</v-toolbar>
						<template v-if="isLoading">
							<div class="text-xs-center pa-5">
								<v-progress-circular :size="50" color="indigo" indeterminate></v-progress-circular>
								<div class="caption mt-4">İşlem devam ediyor</div>
							</div>
						</template>
						<template v-if="!isLoading">

							<v-list>
								<v-card-text>
									<v-container grid-list-md>
										<v-layout wrap>
											<v-flex xs12>
												<v-text-field label="Group adresi" v-model="group.name" :suffix="'@'+domain"
													:disabled="isEdit" />
											</v-flex>
											<v-flex xs12 v-if="isEdit">
												<v-list-tile v-for="(member,memberIndex) in group.members"
													:key="memberIndex" >  
													<v-list-tile-content>
														<v-list-tile-title>{{ member.object.email }}</v-list-tile-title> 
													</v-list-tile-content> 
													<v-list-tile-action>
														<v-btn icon ripple @click="removeMember(memberIndex)">
															<v-icon color="error lighten-1">delete</v-icon>
														</v-btn>
													</v-list-tile-action>
												</v-list-tile>
											</v-flex> 
											<v-flex xs12 v-if="isEdit"> 
												<v-combobox v-model="group.willAppend" :items="users" item-text="text" item-value="value" label="Şunları gruba ekle" multiple chips />
											</v-flex> 
										</v-layout>
										<v-card-actions p-3 v-if="isEdit">
											<v-btn color="error" ml-3 @click="removeDialog = true">Sil</v-btn>
											<v-spacer></v-spacer>
											<v-btn color="success" @click="saveGroup()">KAYDET</v-btn>
										</v-card-actions>
										<v-card-actions p-3 v-if="!isEdit">
											<v-spacer></v-spacer>
											<v-btn color="success" @click="addGroup()">EKLE</v-btn>
										</v-card-actions>
									</v-container>
								</v-card-text>

							</v-list>
						</template>
					</v-card>
				</v-flex>



				<v-dialog v-model="removeDialog" max-width="380">
					<v-card>
						<v-card-title class="headline">Silmek istediğine emin misin ?</v-card-title>
						<v-card-actions>
							<v-spacer></v-spacer>
							<v-btn color="warning" flat="flat" @click="removeDialog = false"> VAZGEÇ </v-btn>
							<v-btn color="error" @click="removeGroup()"> EMİNİM </v-btn>
						</v-card-actions>
					</v-card>
				</v-dialog>


			</v-layout>
		</v-container>
	</v-content>


</template>


<script>
	export default {
		name: "MailOrganizations",

		data: () => ({
			isLoading: false,
			removeDialog: false,

			account: "",
			domain: "",
			domain_id: "",
			group_id: "",

			isEdit: true,


			users: [],
			group: {
				label: "",
				name: "",
				members: [],
				willRemove: [],
				willAppend: [],
			}

		}),

		mounted() {
			this.loadIt();
		},

		methods: {
			loadIt() {
				this.account = this.$route.query.account
				this.domain = this.$route.query.domain
				this.domain_id = this.$route.query.domain_id
				this.group_id = this.$route.query.group_id
				if (this.group_id == "") {
					this.group = {
						label: "",
						name: "",
						members: [],
						willRemove: [],
						willAppend: [],
					}
					this.isEdit = false;
					this.isLoading = false;
				} else {
					this.isLoading = true;
					this.$http.get(process.env.VUE_APP_API_URL + "/email/groups/info", {
						params: {
							account: this.account,
							domain: this.domain,
							domain_id: this.domain_id,
							group_id: this.group_id
						}
					}).then(response => {
						response.body.willRemove = [];
						response.body.willAppend = [];
						this.group = response.body;
						this.isEdit = true;
						this.isLoading = false;
					})
				}
				this.$http.get(process.env.VUE_APP_API_URL + "/email/users", {
					params: {
						account: this.account,
						domain_id: this.domain_id
					}
				}).then(response => {
					for (var i in response.body) {
						this.users.push({
							value : response.body[i].id,
							text : response.body[i].email
						})
					}
				})
			},
			addGroup() {
				this.isLoading = true;
				this.$http.post(process.env.VUE_APP_API_URL + "/email/groups/add", this.group, {
					params: {
						account: this.account,
						domain: this.domain,
						domain_id: this.domain_id,
						user_id: this.user_id
					}
				}).then(response => {
					this.user = response.body;
					this.isLoading = false;
					this.$router.push({
						path: '/email/users',
						query: {
							account: this.account,
							domain: this.domain,
							domain_id: this.domain_id,
						}
					})
				})
			},
			saveGroup() {
				this.isLoading = true;
				this.$http.post(process.env.VUE_APP_API_URL + "/email/groups/edit", this.group, {
					params: {
						account: this.account,
						domain: this.domain,
						domain_id: this.domain_id,
						group_id: this.group_id
					}
				}).then(response => {
					this.user = response.body;
					this.isLoading = false;
					this.loadIt();
				})
			},
			removeUser() {
				this.removeDialog = false;
				this.isLoading = true;
				this.$http.get(process.env.VUE_APP_API_URL + "/email/groups/remove", {
					params: {
						account: this.account,
						domain: this.domain,
						domain_id: this.domain_id,
						group_id: this.group_id
					}
				}).then(response => {
					this.user = response.body;
					this.isLoading = false;
					this.$router.push({
						path: '/email/users',
						query: {
							account: this.account,
							domain: this.domain,
							domain_id: this.domain_id,
						}
					})
				})
			},


			removeMember(memberIndex){
				var member = this.group.members[memberIndex]
				this.group.willRemove.push( member.object.id )
				this.group.members.splice(memberIndex,1);
			},
			gotoUsers(){
				this.$router.go(-1)
			}
		},

		computed: { 
		}

	}
</script>